export const RESET_GLOBAL_APP_STATE = 'RESET_GLOBAL_APP_STATE'
